import { HttpServiceConstants } from '@kimaya/ngx-http-service';
import { AuthService } from '@kimaya/ngx-auth-service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
// Avoid including modules here for circular dependency warning
import { CookieStorage } from '@kimaya/ngx-cookie-storage';
import { CoreConstants, PaginationRequest, SortRequestProto } from '..';
// Declare SockJS and Stomp
declare const SockJS;
declare const Stomp;

export class WebSocketRequest {
  type = 'CHAT';
  action: string;
  pageNumber: number;
  pageSize: number;
  sort: SortRequestProto[];
}

export class SendMessageRequest<T> {
  messageRequest: T;

}

@Injectable({
  providedIn: 'root',
})
export class WebSocketConfigService {

  public stompClient;

  constructor(private readonly authService: AuthService, private cookieStorage: CookieStorage) {
  }

  getHeaderOptions() {
    /*set header section*/
    const httpHeader = {
      token: `${this.authService.getAccessToken()}`,
    };

    /*Set Extra Headers from HttpServiceConstants*/
    if (Object.keys(HttpServiceConstants.headers || {}).length > 0) {
      for (const headerDataKey in HttpServiceConstants.headers) {
        if (HttpServiceConstants.headers.hasOwnProperty(headerDataKey)) {
          httpHeader[headerDataKey] = HttpServiceConstants.headers[headerDataKey];
        }
      }
    }
    return httpHeader;
  }

  connect(successCallBack?, errorCallBack?) {
    if (CoreConstants.socketEnabled) {
      if (!this.stompClient) {
        const serverUrl = `${HttpServiceConstants.serverUrl}/sockconnect`;
        const ws = new SockJS(serverUrl);
        this.stompClient = Stomp.over(ws);
        this.stompClient.ws.withCredentials = 'false';
        this.stompClient.connect(this.getHeaderOptions(), successCallBack, errorCallBack);
      } else if (this.stompClient.connected) {
        if (successCallBack) {
          successCallBack();
        }
      } else {
        this.disconnect();
        this.connect(successCallBack, errorCallBack);
      }
    } else if (successCallBack) {
      successCallBack();
    } else if (errorCallBack) {
      errorCallBack();
    }
  }


  disconnect() {
    if (this.stompClient?.connected) {
      this.stompClient?.disconnect();
    }
    this.stompClient = null;
  }

  sendRequest(actionApiUrl: string, request: any): Observable<any> {
    return new Observable<any>((observer) => {
      if (this.stompClient) {
        this.stompClient.send(
          actionApiUrl,
          this.getHeaderOptions(),
          JSON.stringify(request))?.then((response) => {
          observer.next(JSON.parse(response.body));
          observer.complete();
        }, (err) => {
          observer.error(err);
        });
      } else {
        observer.error('Socket Connection not active');
      }
    });

  }
}
